import request from '@/utils/request'

/**
 * 实名制 AI 查询接口
 *
 * 所有接口自动带 X-Token，后端按 Token 里的 project_id 限定当前项目，
 * 前端不需要也不应该传 project_id。
 */

// Q1 自然语言查询（支持反问/追问，带上下文）
export function aiAsk(question) {
  return request({
    url: 'ai/ask',
    method: 'POST',
    data: { question }
  })
}

// Q1 智能搜索框（多关键词、多字段）
export function aiSmartSearch(keyword, limit) {
  return request({
    url: 'ai/smartSearch',
    method: 'GET',
    params: { keyword, limit: limit || 30 }
  })
}

// Q1 导出结果（传 plan 更准确，避免二次解析）
export function aiExport(payload) {
  return request({
    url: 'ai/export',
    method: 'POST',
    data: payload
  })
}

// Q2 聚合出图
export function aiChart(question) {
  return request({
    url: 'ai/chart',
    method: 'POST',
    data: { question }
  })
}

// Q2 两组对比
export function aiCompare(left, right) {
  return request({
    url: 'ai/compare',
    method: 'POST',
    data: { left, right }
  })
}

// Q3 保存常用查询
export function aiSavedSave(payload) {
  return request({
    url: 'ai/savedSave',
    method: 'POST',
    data: payload
  })
}

// Q3 常用查询列表
export function aiSavedLists() {
  return request({
    url: 'ai/savedLists',
    method: 'GET'
  })
}

// Q3 删除常用查询
export function aiSavedRemove(id) {
  return request({
    url: 'ai/savedRemove',
    method: 'POST',
    data: { id }
  })
}

// Q3 执行常用查询
export function aiSavedRun(id) {
  return request({
    url: 'ai/savedRun',
    method: 'POST',
    data: { id }
  })
}

// Q3 新增订阅
export function aiSubscribe(payload) {
  return request({
    url: 'ai/subscribe',
    method: 'POST',
    data: payload
  })
}

// Q3 订阅列表
export function aiSubscribeLists() {
  return request({
    url: 'ai/subscribeLists',
    method: 'GET'
  })
}

// Q3 取消订阅
export function aiSubscribeCancel(id) {
  return request({
    url: 'ai/subscribeCancel',
    method: 'POST',
    data: { id }
  })
}

// Q3 清空上下文
export function aiClearConversation() {
  return request({
    url: 'ai/clearConversation',
    method: 'POST'
  })
}



// WEBPACK FOOTER //
// ./src/api/ai.js